/*
 * DATEI: assets/aa-mj-hide-unavailable-options.js
 * ZWECK: Blendet "nicht verfügbar"-Optionen in Dropdown-Selects aus
 *
 * PROBLEM:
 * Wenn ein Produkt mehrere Optionen hat (z.B. Artikelnummer + Schrifttyp),
 * zeigt Shopify bei bestimmten Kombinationen Schrifttypen als
 * "Minka – nicht verfügbar" an. Diese sollen komplett ausgeblendet werden.
 *
 * WIE ES FUNKTIONIERT:
 * - Beim Laden der Seite werden alle <option>-Elemente geprüft
 * - Enthält der Text "nicht verfügbar" → wird ausgeblendet (display: none)
 * - Falls die aktuell ausgewählte Option nicht verfügbar ist →
 *   wird automatisch die erste verfügbare Option ausgewählt
 * - Ein MutationObserver überwacht das DOM dauerhaft, damit das Script
 *   auch nach jedem Variantenwechsel (Shopify baut das Dropdown neu auf)
 *   erneut greift
 *
 * EINBINDUNG:
 * In layout/theme.liquid vor </body> eintragen:
 * <script src="{{ 'aa-mj-hide-unavailable-options.js' | asset_url }}" defer></script>
 *
 * NACH THEME-UPDATE:
 * - Diese Datei bleibt erhalten (liegt in assets/) → kein Handlungsbedarf
 * - Nur die Einbindung in theme.liquid prüfen (script_tag-Zeile)
 */

document.addEventListener('DOMContentLoaded', function () {
  function hideUnavailable() {
    document.querySelectorAll('select').forEach(function (select) {
      var currentlySelected = select.value;
      var currentOption = select.querySelector('option[value="' + currentlySelected + '"]');
      var currentIsUnavailable = currentOption && currentOption.textContent.trim().includes('nicht verfügbar');

      select.querySelectorAll('option').forEach(function (opt) {
        if (opt.textContent.trim().includes('nicht verfügbar')) {
          opt.style.display = 'none';
        } else {
          opt.style.display = '';
        }
      });

      if (currentIsUnavailable) {
        var firstAvailable = select.querySelector('option:not([style*="none"])');
        if (firstAvailable) {
          select.value = firstAvailable.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  hideUnavailable();

  var observer = new MutationObserver(function () {
    hideUnavailable();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
